export default __webpack_public_path__ + "static/katalog2020-b48f835570e3fd4bc2789528a0837f42.pdf";